import React from 'react';
import { connect } from 'dva';
import { withRouter, Link } from 'dva/router';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Table, Tooltip, Modal, Button, Row, Col, Icon, Form } from 'antd';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { PencilIcon, TrashIcon } from '../../Icons';
import { ROUTE_CAMPAIGNS_NEW } from '../../../routes';
import styles from '../styles.less';

class CampaignsList extends React.Component {
  constructor(props) {
    super(props);
    this.projectId = this.props.app.currentProjectId || this.props.match.params.projectId;
    this.state = {
      removedId: 0,
      filter: {},
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Campaigns.List.Title',
      },
    });
  }

  getData = (psf) => {
    return this.props.dispatch({
      type: 'campaigns/loadList',
      payload: {
        projectId: this.projectId,
        ...psf,
        filter: {
          label: this.state.filter.search,
        },
      },
    });
  }

  confirmDelete = (item) => {
    return Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.Campaigns.Modal.Description' },
        { campaignName: item.name },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => {
        this.removeItem(item.id);
      },
    });
  }

  removeItem = (campaignId) => {
    const payload = { projectId: this.projectId, campaignId };
    this.props.dispatch({ type: 'campaigns/removeCampaign', payload }).then((response) => {
      if (response.success) {
        this.showNotification().then(() => this.setState({ removedId: campaignId }));
      }
    });
  }

  showNotification = () => {
    return this.props.dispatch({
      type: 'app/addNotification',
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: 'Component.Campaigns.Remove.Success.Text',
      },
    }).then(() => this.props.dispatch({ type: 'app/showNotifications' }));
  }

  goToRoute = (routeName) => {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        projectId: this.projectId,
        routeName,
      },
    });
  }

  render() {
    const { Column } = Table;
    return (
      <React.Fragment>
        <div className={styles.containerLarge}>
          <Sticky
            className="sticky-bar"
            scrollElement=".ant-layout"
            stickyClassName="_sticky"
          >
            <div className="sticky-wrapper">
              <Row>
                <SearchComponent self={this} fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.Campaigns.List.SearchPlaceholder' })} />
                <Col span={14} className="text-right">
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => this.goToRoute(ROUTE_CAMPAIGNS_NEW)}
                  >
                    <Icon type="plus" />
                    <FormattedMessage id="Component.Campaigns.Create" />
                  </Button>
                </Col>
              </Row>
            </div>
          </Sticky>
        </div>
        <AjaxTable
          rowKey="id"
          getData={this.getData.bind(this)}
          updateKey={JSON.stringify([this.state.removedId, this.state.filter])}
        >
          <Column
            title={this.props.intl.formatMessage({ id: 'Grid.Column.Label' })}
            key="label"
            dataIndex="label"
            sorter
          />
          <Column
            title={this.props.intl.formatMessage({ id: 'Grid.Column.Key' })}
            key="key"
            dataIndex="key"
            sorter
          />
          <Column
            title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
            key="name"
            dataIndex="name"
            sorter
          />
          <Column
            title={this.props.intl.formatMessage({
              id: 'Grid.Column.Actions',
            })}
            key="actions"
            className="text-center"
            width={150}
            fixed="right"
            render={item => (
              <div className="actions" data-label={item.id}>
                <Tooltip
                  className="hint action-wrap"
                  placement="top"
                  title={this.props.intl.formatMessage({
                    id: 'Grid.Column.Edit',
                  })}
                >
                  <Link to={`./${item.id}/edit/`}>
                    <PencilIcon />
                  </Link>
                </Tooltip>
                <Tooltip
                  className="hint action-wrap"
                  placement="top"
                  title={this.props.intl.formatMessage({
                    id: 'Grid.Column.Delete',
                  })}
                >
                  <button onClick={() => this.confirmDelete(item)}>
                    <TrashIcon />
                  </button>
                </Tooltip>
              </div>
            )}
          />
        </AjaxTable>
      </React.Fragment>
    );
  }
}

export default withRouter(connect(({ app, loading, campaigns }) => ({ app, loading, campaigns }))(Form.create()(injectIntl(CampaignsList))));



// WEBPACK FOOTER //
// ./src/components/Campaigns/CampaignsList/CampaignsList.js